console.log('variant color availability loaded');

const variants = window.productVariants || [];

function updateColorAvailability() {
  const selected = {};

  document.querySelectorAll('.js-option:checked').forEach(input => {
    const box = input.closest('.option-selector');
    if (box) {
      selected[box.dataset.option] = input.value;
    }
  });

  document.querySelectorAll('.js-option').forEach(input => {
    const box = input.closest('.option-selector');

    if (!box) return;

    // 只处理 Color
    if (box.dataset.option !== 'Color') {
      return;
    }

    const color = input.value;

    const possible = variants.some(variant => {
      if (!variant.available) {
        return false;
      }
      return variant.options[0] === color && (!selected.Size || variant.options[1] === selected.Size);
    });

    const label = document.querySelector(`label[for="${input.id}"]`);

    if (label) {
      label.classList.toggle('is-unavailable', !possible);
    }
  });
}

document.addEventListener('change', function(e) {
  if (e.target.matches('.js-option')) {
    setTimeout(updateColorAvailability, 100);
  }
});

setTimeout(updateColorAvailability, 300);